import { render, staticRenderFns } from "./swiper-custom.vue?vue&type=template&id=45771284"
import script from "./swiper-custom.vue?vue&type=script&lang=js"
export * from "./swiper-custom.vue?vue&type=script&lang=js"
import style0 from "./swiper-custom.vue?vue&type=style&index=0&id=45771284&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports